import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProductPromise } from './components/ProductPromise';
import { ProblemSection } from './components/ProblemSection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { TransformationSection } from './components/TransformationSection';
import { BonusStack } from './components/BonusStack';
import { UrgencyBlock } from './components/UrgencyBlock';
import { ContentPreview } from './components/ContentPreview';
import { PricingOptions } from './components/PricingOptions';
import { PackComparison } from './components/PackComparison';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { OpportunityCost } from './components/OpportunityCost';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="min-h-screen bg-clinical-base font-sans text-clinical-ink overflow-x-hidden" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <ContentPreview data-id="element-3" />
      <ProductPromise data-id="element-4" />
      <ProblemSection data-id="element-5" />
      <WhatsIncluded data-id="element-6" />
      <TransformationSection data-id="element-7" />
      <BonusStack data-id="element-8" />
      <UrgencyBlock data-id="element-9" />
      <PricingOptions data-id="element-10" />
      <PackComparison data-id="element-11" />
      <Testimonials data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <OpportunityCost data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
      <PurchaseNotifications data-id="element-18" />
      <WhatsAppFloat data-id="element-19" />
    </div>;
}